$(document).ready(function () {
    $('form.form').attr("novalidate", true).on("submit", function (event) {
        const method = $(this).attr("method");
        const form = $(this);
        const url = $(this).attr("action");
        const successModal = $(this).data("success-modal") || false;
        const errorModal = $(this).data("error-modal") || false;
        const isTokenValidation = $(this).hasClass("form-validation");
        
        sendForm(method, form, url, event, successModal, errorModal, isTokenValidation);
    });
});

// Walidacja tokena
function sendForm(method, form, endpoint, event, successModal, errorModal, tokenValidation = false) {
    event.preventDefault();

    $('button[type="submit"]').prop('disabled', true);
   
    if (tokenValidation) {
        $.ajax({
            type: "POST",
            dataType: 'json',
            data: {
                'action': 'generate-token',
            },
            url: BASE_URL + "/ax_contact",
            success: function (res) {
                if (!res.fieldName || !res.token) {
                    alert('Error security token generation');
                    $('button[type="submit"]').prop('disabled', false);
                    return;
                }
                
                $('#tokenField').attr('name', res.fieldName).val(res.token);
                submitForm(method, form, endpoint, successModal, errorModal);
            },
            error: function (error) {
                $('button[type="submit"]').prop('disabled', false);
                alert('Error security token generation');
                console.error("🚀 ~ sendForm ~ error:", error);
            }
        });
        return;
    }

    submitForm(method, form, endpoint, successModal, errorModal);
}

// Wysyłanie ajaxem
function submitForm(method, form, endpoint, successModal, errorModal) {
    form.find('.text-error').hide();
    form.find(':required').each(function () {
        $(this).removeClass('input-error');
    });

    $('button[type="submit"]').prop('disabled', true);

    if (form.find(".captcha-container .text-error").length) {
        form.find(".captcha-container .text-error").remove();
    }

    if (!form[0].checkValidity()) {
        form.find(":required").each(function () {
            if (!this.checkValidity()) {
                $(this).addClass("input-error");
            }
        });
        $('button[type="submit"]').prop('disabled', false);
        return;
    }

    const formData = new FormData(form[0]);

    $.ajax({
        type: method,
        dataType: 'json',
        data: formData,
        contentType: false,
        processData: false,
        url: BASE_URL + endpoint,
        success: function (response) {
            if (!response.status || response.status === "success") {
                form[0].reset();
                $('button[type="submit"]').prop('disabled', false);

                if (successModal) {
                    closeModal();
                    openModal(successModal);
                }

                if (form.data("redirect-url")) {
                    window.location.href = form.data("redirect-url");
                }

                return;
            }

            if (response.error_type === "captcha_invalid" && response.view) {
                $(".captcha-container").replaceWith(response.view);
                form.find('.text-error').show();
                $('button[type="submit"]').prop('disabled', false);
                return;
            }

            if (errorModal.length) {
                closeModal();
                openModal(errorModal);
                $('button[type="submit"]').prop('disabled', false);
                return;
            }

            if (form.find('.text-error').length && response.message) {
                form.find('.text-error').text(response.message).show();
                $('button[type="submit"]').prop('disabled', false);
                return;
            }

            alert('Error: ' + (response.message || 'Unknown error'));
            console.error("🚀 ~ submitForm ~ error response:", response);
            $('button[type="submit"]').prop('disabled', false);
        },
        error: function (xhr, status, error) {
            if (errorModal.length) {
                closeModal();
                openModal(errorModal);
            } else {
                closeModal();
                alert('Error: ' + error);
            }

            $('button[type="submit"]').prop('disabled', false);
        }
    });
}
